import { Link } from "react-router-dom";
import { FC, useContext, useEffect, useMemo, useState } from "react";
import { AppContext } from "../../../App";
import InfoPanel from "../InfoPanel/InfoPanel";
import ArrowButton from "../../buttons/ArrowButton/ArrowButton";
import { Context } from "../../..";
import ProjectComponent from "./ProjectComponent";
import { hasPermission } from "../../../helpers/hasPermisson";
import { ISideBarProject } from "../../../common/api_interfaces/common/ISideBar";

export type HighlightOptions = "projects" | "monitor" | "archive" | "basket";

export interface INavBarInfo {
    projectId?: number;
    subprojectId?: number;
    boardId?: number;
    openProjectIds?: number[];
    openBoardIds?: number[];
}

interface NavigationPanelProps {
    collapsed: boolean;
}

const NavigationPanel: FC<NavigationPanelProps> = ({ collapsed }) => {
    const { sideBarProjects, navPanelHighlight, navBarInfo, systemUserAccess } = useContext(AppContext);
    const [projectListOpen, setProjectListOpen] = useState<boolean>(false);
    const { store } = useContext(Context);

    //ролевая модель
    const viewMonitor = useMemo(() => hasPermission(systemUserAccess, "UserMonitorAction", "view"), [systemUserAccess]);
    const viewProjects = useMemo(() => hasPermission(systemUserAccess, "SystemProjectAction", "view"),[systemUserAccess]);
    const viewArchive = useMemo(() => hasPermission(systemUserAccess, "ArchiveAction", "view"), [systemUserAccess]);
    const viewBasket = useMemo(() => hasPermission(systemUserAccess, "BasketAction", "view"), [systemUserAccess]);

    useEffect(() => {
        if (navPanelHighlight === "projects") {
            setProjectListOpen(true);
        }

        if ((navBarInfo?.projectId || navBarInfo?.subprojectId || navBarInfo?.boardId) && navPanelHighlight !== "archive") {
            setProjectListOpen(true);
        }
    }, [navPanelHighlight, navBarInfo]);

    return (
        <div className="nav-panel">
            {viewProjects ? (
                <Link
                    className={`nav-panel_item ${navPanelHighlight === "projects" ? "highlighted" : ""}`}
                    to={"/projects"}
                >
                    <div className="nav-panel_projects-container">
                        <div className="nav-panel_label-container">
                            <div className="image-placeholder project" />
                            {!collapsed ? <div className={`nav-panel_label`}>Проекты</div> : null}
                        </div>
                        {!collapsed ? (
                            <div className="nav-panel_project-icons">
                                <InfoPanel count={sideBarProjects?.length} idKey="projectCount" />
                                <ArrowButton
                                    onClick={(e) => {
                                        e.preventDefault();
                                        setProjectListOpen(!projectListOpen);
                                    }}
                                    direction={projectListOpen ? "top" : "bottom"}
                                    whiteArrow={navPanelHighlight === "projects"}
                                />
                            </div>
                        ) : null}
                    </div>
                </Link>
            ) : null}
            {viewProjects ? (
                <div className="nav-panel_projects-list">
                    {!collapsed && projectListOpen
                        ? (sideBarProjects as ISideBarProject[]).map((project) => (
                              <ProjectComponent key={`project-${project.id}`} project={project} />
                          ))
                        : null}
                </div>
            ) : null}
            {viewMonitor ? (
                <Link
                    className={`nav-panel_item ${navPanelHighlight === "monitor" ? "highlighted" : ""}`}
                    to={"/monitor"}
                >
                    <div className="nav-panel_label-container">
                        <div className="image-placeholder monitor" />
                        {!collapsed ? <div className="nav-panel_label">Монитор пользователя</div> : null}
                    </div>
                </Link>
            ) : (
                <div></div>
            )}
            {!store.getBlockArchive() && viewArchive ? (
                <Link
                    className={`nav-panel_item ${navPanelHighlight === "archive" ? "highlighted" : ""}`}
                    to={"/archive"}
                >
                    <div className="nav-panel_label-container">
                        <div className="image-placeholder archive" />
                        {!collapsed ? <div className="nav-panel_label">Архив</div> : null}
                    </div>
                </Link>
            ) : (
                <div></div>
            )}
            {viewBasket ? (
                <Link
                    className={`nav-panel_item ${navPanelHighlight === "basket" ? "highlighted" : ""}`}
                    to={"/basket"}
                >
                    <div className="nav-panel_label-container">
                        <div className={`image-placeholder ${collapsed ? "collapsed" : ""} trash`} />
                        {!collapsed ? <div className="nav-panel_label">Корзина</div> : null}
                    </div>
                </Link>
            ) : (
                <div></div>
            )}
        </div>
    );
};

export default NavigationPanel;
